import styled from 'styled-components';
import theme from 'fe-appdir-lib-theme';

const AppCardMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 0;
  background-color: ${theme.colorGrey95};
`;

AppCardMain.displayName = 'AppCardMain';

export { AppCardMain };
